import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const RatePoliciesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help-policies", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Subscriber Rate Policies"
      onClose={doClose}
      content={() => (
        <>
          <p>
            Define actions to take on subscribers or subscriber-groups assigned
            to this policies.
          </p>
          <ul>
            <li>
              <b>BLOCK</b>: Block subscribers (traffic is dropped). Does not
              apply to subscribers assigned as part of a subscriber group, only
              to subscribers directly assigned to this policy.
            </li>
            <li>
              <b>RATE-LIMIT-DOWN</b>: Rate limit in the downlink direction.
            </li>
            <li>
              <b>RATE-LIMIT-UP</b>: Rate limit in the uplink direction.
            </li>
            <li>
              <b>FLOW-LIMIT</b>: Maximum number of flows per subscriber
              enforced.
            </li>
            <li>
              <b>ACM</b>: Automatic Congestion Management feature, "enabled" if
              active. Does not apply to subscribers assigned as part of a
              subscriber group, only to subscribers directly assigned to this
              policy.
            </li>
            <li>
              <b>CONFIGURED</b>: Whether the policy was configured through the
              GUI or CLI. If "no", it means it has been defined by REST, RADIUS
              or by a Billing system.
            </li>
            <li>
              <b>ACTIONS</b>: Allowed operations on this policy (e.g. delete or
              edit).
            </li>
          </ul>
          <p>
            Click on the <i class="material-icons valign-icon">delete</i> icon
            to delete an already configured policy.
          </p>
          <p>
            Press the <i class="material-icons valign-icon">more_vert</i> icon
            and then select the <b>Add Policy...</b> option to add a new Policy.
          </p>
          <p>
            Click on the <i class="material-icons valign-icon">refresh</i> icon
            to refresh policies information.
          </p>
        </>
      )}
      onClose={doClose}
    />
  );
};
export default RatePoliciesHelpModal;
